// Styles
import styles from './FormContainer.module.css';

/**
 * FormContainer component
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @returns {JSX.Element}
 */
function FormContainer({ children }) {
  return (
    <div className={styles['form-container']}>
      {children}
    </div>
  );
}

export default FormContainer;
